import OrderApi from "@/services/api/orderApi.js";

const OrderApiService = new OrderApi();

export default {
  data() {
    return {
      invoice: null,
    };
  },

  methods: {
    getInvoice,
    navigateToRetailersProfile,
  },

  beforeMount() {
    this.getInvoice();
  },
};

async function getInvoice() {
  this.$loader.$emit("trigger", true);

  OrderApiService.getPayment(this.$route.params.suborderId)
    .then((response) => {
      this.invoice = response.data;
    })
    .catch((error) => {
      if (error.response) {
        this.$swal("Attention", error.response.data.error_message);
      } else {
        this.$bugsnagClient.notify(new Error(error));
      }
    })
    .finally(() => this.$loader.$emit("trigger", false));
}

function navigateToRetailersProfile(retailerId) {
  this.$router.push({
    path: `/retailer/${retailerId}`,
  });
}
